<template>
    <v-row justify="center" align="start" class=" ma-0 pa-0 full-map-row">
      <v-col cols="12" sm="10" md="10" lg="10" xl="10" class="pa-0">
          <v-row justify="center" class="ma-0 pa-0">
            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
              <v-row justify="space-around">
            <v-col cols="3" sm="2" md="2" lg="2" xl="2">
              <v-img :src="imgF1" @click="selectFloor('1')" class="cursor-url"></v-img>

            </v-col>
            <v-col cols="3" sm="2" md="2" lg="2" xl="2">
              <v-img :src="imgF2" @click="selectFloor('2')" class="cursor-url"></v-img>

            </v-col>
            <v-col cols="3" sm="2" md="2" lg="2" xl="2">
              <v-img :src="imgF3" @click="selectFloor('3')" class="cursor-url"></v-img>

            </v-col>
              </v-row>
            </v-col>
          </v-row>

      <v-row  class="info-shop pa-0 ma-0" justify="center" align="center">
        <v-col cols="4" sm="1" md="1" lg="1" xl="1" class=" pa-0 ma-0 d-flex child-flex" v-if="hoverShopData !== null">
          <v-img
          :src="hoverShopData.logoHS"
          v-show="hoverShopData.logoHS!==''"
          >
              <template v-slot:placeholder>
                <v-row
                  class="ma-0"
                  align="center"
                   justify="center"
                >
                  <v-progress-circular indeterminate color="grey darken-1"></v-progress-circular>
                </v-row>
              </template>

          </v-img>
        </v-col>
        </v-row>

        <v-row   class="info-shop pa-0 ma-0"  justify="center" align="center">
        <v-col cols="6" sm="3" md="3" lg="3" xl="3"  class="title white--text pa-0 ma-0" v-show="hoverShopData.nameHS!==''" v-if="hoverShopData !== null">
          {{hoverShopData.nameHS}}
        </v-col>
      </v-row>


      <v-row justify="center" class="pa-0 ma-0" >
        <v-col class="pa-0" cols="12">
        <div id="fullmap" class="maprender  d-flex justify-center"></div>
        </v-col>
      </v-row>

      <div class="mob-btn-gotoshop " v-show="isViewBtnGotoShop">
        <v-btn @click="slectShopFromAllMap(getIdClickShop)">Перейти к магазину</v-btn>
      </div>

      </v-col>
</v-row>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';

export default {
  name: 'AllMapPage',
  components: {

  },
  data: () => ({
      idSelectShop:null,
      isViewBtnGotoShop: false,
      getIdClickShop: null,
      selectShop:null,
      camera: null,
      camera2: null,
      scene: null,
      controls: null,
      needsResize: false,
      resizeTimeout: null,
      groupFl1: new THREE.Group(),
      groupFl2: new THREE.Group(),
      groupFl3: new THREE.Group(),
      normal3: require('@/assets/texture/concrete.jpg'),
      normal4: require('@/assets/texture/brick_bump.jpg'),
      imgF1: require('@/assets/1_floor.jpg'),
      imgF2: require('@/assets/2_floor.jpg'),
      imgF3: require('@/assets/3_floor.jpg'),
      selectMaterial: null,
      grpMaterial: null,
      cubeMat: null,
      mapBlock:null,
      mapDimention:null,
      mapBaseF1:null,
      mapSpotsF1:null,
      mapBaseF2:null,
      mapSpotsF2:null,
      mapBaseF3:null,
      mapSpotsF3:null,
      renderer: null,
      light: null,
      mesh: null,
      stats: null,
      californiaShape: null,
      floorShape: [],
      shopsShape: [],
      targetRotation: 0,
			targetRotationOnMouseDown: 0,
			mouseX: 0,
      mouseXOnMouseDown: 0,
      arrBase: null,
      arrFloor: null,
      mouse: null,
      raycaster: null,
      INTERSECTED: null,
      hoverShopID: null,
      hoverShopData: null,
      intersects: null,
      mMove: false


  }),
  watch:{
    allSh(wsh){
      let vApp = this;
      if(DEBUG) console.log('wsh :', wsh);
      if(vApp.scene === null){
/*       vApp.init();
      vApp.animate(); */
      }
    },
    hoverShopID(nID) {
          let vApp = this;
          let hovShop = null;

          if (vApp.hoverShopID !== 'none'){
          if (vApp.hoverShopID === null){
          hovShop = vApp.allSh.find(fsh=>fsh.id === vApp.$route.params.idShop);
          if(DEBUG) console.log('hovShop :', hovShop);
          //vApp.hoverShopData = {nameHS: hovShop.nameK, logoHS: `http://api.trcgagarinsky.ru/terminal__tmp/`+ hovShop.logourl};
          vApp.hoverShopData = {nameHS: hovShop.nameK, logoHS: hovShop.anchor_logo};
          }
          else{
          hovShop = vApp.allSh.find(fsh=>'sh-'+fsh.idmapshop === vApp.hoverShopID);
          if(typeof hovShop !== 'undefined') {
        //  if(DEBUG) console.log('hovShop :', hovShop);
          //vApp.hoverShopData = {nameHS: hovShop.nameK, logoHS: `http://api.trcgagarinsky.ru/terminal__tmp/`+ hovShop.logourl};
          vApp.hoverShopData = {nameHS: hovShop.nameK, logoHS: hovShop.anchor_logo};
          }
          else {
             if(DEBUG) console.log(' *********************  ============ НАЗВАНИЕ ДОЛЖНО БЫТЬ ПУСТЫМ');
            vApp.hoverShopData = {nameHS: '', logoHS: ''};
          }
          }
          }
          else{
              vApp.hoverShopData = {nameHS: '', logoHS: ''};
          }

    }

  },
  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },
      isMobile: {
      get () {
        return this.$store.state.app.isMobile
      }
      
    },

        categories: {
          get () {
            return this.$store.getters.getCategories;
          }
        },
        currentShop: {
          get () {
            return this.$store.state.shops.currentShop;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setCurrentShop', val)
          }
        },
        titleInnert: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.titleInner);
            return this.$store.state.app.titleInner;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setTitleInner', val)
          }
        },
        nameShopHover(){
          let vApp = this;
          let hovShop = null;
          if (vApp.hoverShopID === null){
          hovShop = vApp.shops.find(fsh=>fsh.id === vApp.$route.params.idShop);
          if(DEBUG) console.log('hovShop :', hovShop);
          //return {nameHS: hovShop.nameK, logoHS: `http://api.trcgagarinsky.ru/terminal__tmp/`+ hovShop.logourl};
          return {nameHS: hovShop.nameK, logoHS: hovShop.anchor_logo};
          }
        },
        allSh: {
          get () {
                if(DEBUG) console.log('this.$store.state.category :', this.$store.state.shops.shops);
                return this.$store.state.shops.shops;
              },
        },
        windowHalfX()  {
          return window.innerWidth / 2;
        },
        shops() {
          let vApp = this;

          let allShops= vApp.$store.state.shops.shops;
          let filterOnly;
          if (allShops !== null) {
          filterOnly = allShops.filter((allI)=>{
           return (!allI.category.includes('50') && !allI.category.includes('43') && !allI.category.includes('37'));
          });
          if(DEBUG) console.log('filterOnly :', filterOnly);

            return filterOnly;
          }
          },
        viewAllMapDialog: {
            get () {
              return this.$store.state.maps.viewAllMapDialog
            },
            set (value) {
              this.$store.dispatch('setViewAllMapDialog', value)
            }
          },
        loadPathData: {
          get () {
            return this.$store.getters.getLoadPathData
          }
        },
  },
    methods: {
      slectShopFromAllMap(nShop){
        let vApp = this;
        if(DEBUG) console.log('AllMaps GOTO ===============> nShop :', nShop);
        vApp.currentShop = nShop;

      if(DEBUG) console.log('vApp.categories :>> ', vApp.categories);

      for (let index = 0; index < vApp.categories.length; index++) {
        const elc = vApp.categories[index];

        if(DEBUG) console.log('elc.category :>> ', elc.category);
        let findSubC = elc.category.find(fsc=>fsc.id === nShop.category[0])

        if(DEBUG) console.log('findSubC :>> ', findSubC)

        if( typeof findSubC !== 'undefined'  ){
          if(DEBUG) console.log('  SUBCATEGORY findSubC :>> ', findSubC);
          if(DEBUG) console.log('elc.id GO TO ROUTE ID:>> ', elc.id);



      switch (elc.id) {
        case '10':
          vApp.$router.push('/'+vApp.loadPathData.mnuShopsPath+'/'+nShop.slug);
          break;
        case '15':
          vApp.$router.push('/'+vApp.loadPathData.mnuCafePath+'/'+nShop.slug);
          break;

        case '16':
          vApp.$router.push('/'+vApp.loadPathData.mnuEntertatmentPath+'/'+nShop.slug);
          break;
        case '17':
          vApp.$router.push('/'+vApp.loadPathData.mnuServicePath+'/'+nShop.slug);
          break;

        default:
          break;
      }
        }

      }

        vApp.viewAllMapDialog = false;
      },
      throttle(func, ms) {

        let isThrottled = false,
          savedArgs,
          savedThis;

        function wrapper() {

          if (isThrottled) { // (2)
            savedArgs = arguments;
            savedThis = this;
            return;
          }

          func.apply(this, arguments); // (1)

          isThrottled = true;

          setTimeout(function() {
            isThrottled = false; // (3)
            if (savedArgs) {
              wrapper.apply(savedThis, savedArgs);
              savedArgs = savedThis = null;
            }
          }, ms);
        }

        return wrapper;
      },
      resizeThrottler() {
        let vApp = this;
          // ignore resize events as long as an actualResizeHandler execution is in the queue
          if ( !vApp.resizeTimeout ) {
            vApp.resizeTimeout = setTimeout(function() {
              vApp.resizeTimeout = null;
              vApp.updateViewport();
              if(DEBUG) console.log('update resize ');
            // The actualResizeHandler will execute at a rate of 15fps
            }, 66);
          }
        },
/*
* Апдейт сцены при изменении размеров экрана
*/              
      updateViewport() {
        let vApp = this;
          if(DEBUG) console.log('fov :', Math.atan(vApp.mapBlock.offsetHeight / 2 / -vApp.camera.position.z) * 2 * THREE.Math.RAD2DEG);
          if(DEBUG) console.log('vApp.camera :>> ', vApp.camera);
/*           vApp.camera.fov = 25;
        vApp.camera.zoom = 2.2;
          vApp.camera.aspect = vApp.mapBlock.offsetWidth / vApp.mapBlock.offsetHeight;
          vApp.camera.updateProjectionMatrix();
          vApp.renderer.setSize(vApp.mapBlock.offsetWidth , vApp.mapBlock.offsetHeight); */
if(vApp.isMobile){
          vApp.camera.fov = 25;
          vApp.camera.zoom = 2.2;
  /*         vApp.camera.aspect = vApp.mapBlock.offsetWidth / vApp.mapBlock.offsetHeight;
          vApp.camera.updateProjectionMatrix();
          vApp.renderer.setSize(vApp.mapBlock.offsetWidth , vApp.mapBlock.offsetHeight);
 */

      vApp.camera.position.set( 62, 100, -120 );
        vApp.camera.rotation.set (-0.90*Math.PI, -0.01*Math.PI, 0.0*Math.PI);

        if(DEBUG) console.log('vApp.camera :', vApp.camera);
}
else{
      vApp.camera.position.set( 220, 320, -250 );
        vApp.camera.rotation.set (-0.85*Math.PI, 0.0*Math.PI, 0.0*Math.PI);
        vApp.camera.fov = 25;
        vApp.camera.zoom = 2.2;
        if(DEBUG) console.log('vApp.camera :', vApp.camera);
}
          /* vApp.camera.fov = Math.atan(vApp.mapBlock.offsetHeight / 2 / -vApp.camera.position.z) * 2 * THREE.Math.RAD2DEG-40;
          vApp.camera.aspect = vApp.mapBlock.offsetWidth / vApp.mapBlock.offsetHeight;
          vApp.camera.updateProjectionMatrix();
          vApp.renderer.setSize(vApp.mapBlock.offsetWidth , vApp.mapBlock.offsetHeight); */
      },
/*
* Выбор этажа
*/      
      selectFloor(nFlSel){
        let vApp = this;
        if(DEBUG) console.log('nFlSel :', nFlSel);
        vApp.isViewBtnGotoShop = false
        switch (nFlSel) {
          case '1':
            vApp.mouse = new THREE.Vector2();
              vApp.arrBase =vApp.getBasePoints(1);
              vApp.arrFloor =vApp.getShopPoints(1);
              if(DEBUG) console.log('vApp.arrBase:', vApp.arrBase);
              if(DEBUG) console.log('vApp.arrFloor:', vApp.arrFloor);              
              vApp.addShapeObj(vApp.arrBase,vApp.arrFloor,1);

            break;
          case '2':
            vApp.mouse = new THREE.Vector2();
              vApp.arrBase =vApp.getBasePoints(2);
              vApp.arrFloor =vApp.getShopPoints(2);
              if(DEBUG) console.log('vApp.arrBase:', vApp.arrBase);
              if(DEBUG) console.log('vApp.arrFloor:', vApp.arrFloor);              
              vApp.addShapeObj(vApp.arrBase,vApp.arrFloor,2);

            break;
          case '3':
            vApp.mouse = new THREE.Vector2();
              vApp.arrBase =vApp.getBasePoints(3);
              vApp.arrFloor =vApp.getShopPoints(3);
              if(DEBUG) console.log('vApp.arrBase:', vApp.arrBase);
              if(DEBUG) console.log('vApp.arrFloor:', vApp.arrFloor);
              vApp.addShapeObj(vApp.arrBase,vApp.arrFloor,3);

            break;

          default:
            break;
        }
      },
PointReal(realWidth, realHeight, xPercent, yPercent) {

        return { x: (xPercent * realWidth) / 100, y: (yPercent * realHeight) / 100 };
    },

getBasePoints(nFloor){
        let vApp = this;
        let aspectRatio = null;
        if(DEBUG) console.log('container :', vApp.mapBlock.getBoundingClientRect());

        let spots = null;
        switch (nFloor) {
          case 1:
            spots = vApp.mapBaseF1;
            break;
          case 2:
            spots = vApp.mapBaseF2;
            break;
          case 3:
            spots = vApp.mapBaseF3;
            break;

          default:
            break;
        }


        let getWidthDIV = vApp.mapBlock.getBoundingClientRect().width;
        let getHeightDIV = vApp.mapBlock.getBoundingClientRect().height;

        if (vApp.mapDimention.width > vApp.mapDimention.height) {
            aspectRatio = vApp.mapDimention.height / vApp.mapDimention.width;
        } else {
            aspectRatio = vApp.mapDimention.height / vApp.mapDimention.width;
        }
        let widthMapOriginal = vApp.mapDimention.width;
        let heightMapOriginal = vApp.mapDimention.height;
        let heightMapPut = getWidthDIV * aspectRatio;
        getHeightDIV = heightMapPut;

        let resizeCoeff = (getWidthDIV * 100) / widthMapOriginal;
        if(DEBUG) console.log('heightMapPut :', heightMapPut);
        if(DEBUG) console.log('resizeCoeff :', resizeCoeff);
        if(DEBUG) console.log('spots :', spots);
        let LTStartShape = [];
        let arrPointsShape = [];

        for (let key = 0; key < spots.length; key++) {
                  const currSpot = spots[key];
                  const currShapeWidth = currSpot.width * getWidthDIV / 100;
                  const currShapeHeight = currSpot.height * getHeightDIV / 100;
                  LTStartShape.push(vApp.PointReal(getWidthDIV, heightMapPut, currSpot.x, currSpot.y));
                  let singleShapePoints = [];
                    if(DEBUG) console.log('currSpot :', currSpot);

                      for (let idxp = 0; idxp < currSpot.points.length; idxp++) {
                          const curPoint = currSpot.points[idxp];
                          const currX = LTStartShape[key].x + ((curPoint.x * currShapeWidth) / 100);
                          const currY = LTStartShape[key].y + ((curPoint.y * currShapeHeight) / 100);
                        //  stringPoints += currX + ',' + currY + ',';
                          singleShapePoints.push({ x: Math.floor(currX), y: Math.floor(currY) });
                       }
                      arrPointsShape.push(singleShapePoints);
                      if(DEBUG) console.log('arrPointsShape :', arrPointsShape);
                    //  stringPoints = stringPoints.slice(0, stringPoints.length - 1);
        }
        return arrPointsShape;
},
getShopPoints(nFloor){
        let vApp = this;
        let aspectRatio = null;

        if(DEBUG) console.log('container :', vApp.mapBlock.getBoundingClientRect());
        let spots = null;
        switch (nFloor) {
          case 1:
            spots = vApp.mapSpotsF1;
            break;
          case 2:
            spots = vApp.mapSpotsF2;
            break;
          case 3:
            spots = vApp.mapSpotsF3;
            break;

          default:
            break;
        }

        let getWidthDIV = vApp.mapBlock.getBoundingClientRect().width;
        let getHeightDIV = vApp.mapBlock.getBoundingClientRect().height;

        if (vApp.mapDimention.width > vApp.mapDimention.height) {
            aspectRatio = vApp.mapDimention.height / vApp.mapDimention.width;
        } else {
            aspectRatio = vApp.mapDimention.height / vApp.mapDimention.width;
        }
        let widthMapOriginal = vApp.mapDimention.width;
        let heightMapOriginal = vApp.mapDimention.height;
        let heightMapPut = getWidthDIV * aspectRatio;
        getHeightDIV = heightMapPut;

        let resizeCoeff = (getWidthDIV * 100) / widthMapOriginal;
        if(DEBUG) console.log('heightMapPut :', heightMapPut);
        if(DEBUG) console.log('resizeCoeff :', resizeCoeff);
        if(DEBUG) console.log('spots :', spots);
        let LTStartShape = [];
        let arrPointsShape = [];

        for (let key = 0; key < spots.length; key++) {
                  const currSpot = spots[key];
                  const currShapeWidth = currSpot.width * getWidthDIV / 100;
                  const currShapeHeight = currSpot.height * getHeightDIV / 100;
                  LTStartShape.push(vApp.PointReal(getWidthDIV, heightMapPut, currSpot.x, currSpot.y));
                  let singleShapePoints = [];
                  //  if(DEBUG) console.log('currSpot :', currSpot);

                      for (let idxp = 0; idxp < currSpot.points.length; idxp++) {
                          const curPoint = currSpot.points[idxp];
                          const currX = LTStartShape[key].x + ((curPoint.x * currShapeWidth) / 100);
                          const currY = LTStartShape[key].y + ((curPoint.y * currShapeHeight) / 100);
                        //  stringPoints += currX + ',' + currY + ',';
                          singleShapePoints.push({ x: Math.floor(currX), y: Math.floor(currY) });
                       }
                      arrPointsShape.push(singleShapePoints);
                    //  if(DEBUG) console.log('arrPointsShape :', arrPointsShape);
                    //  stringPoints = stringPoints.slice(0, stringPoints.length - 1);
        }
        return arrPointsShape;
},

    init() {
        let vApp = this;
        if(DEBUG) console.log('floor1Base :', vApp.$store.state.maps.basef1);
        vApp.mapDimention = {
          width: vApp.$store.state.maps.basef1.general.width,
          height: vApp.$store.state.maps.basef1.general.height
        }

        vApp.groupFl1.name = "groupFloor1";
        if(DEBUG) console.log('vApp.groupFl1 :', vApp.groupFl1);
        vApp.mapBaseF1 = vApp.$store.state.maps.basef1.spots;
        vApp.mapSpotsF1 = vApp.$store.state.maps.shopsf1.spots;
        vApp.mapBaseF2 = vApp.$store.state.maps.basef2.spots;
        vApp.mapSpotsF2 = vApp.$store.state.maps.shopsf2.spots;
        vApp.mapBaseF3 = vApp.$store.state.maps.basef3.spots;
        vApp.mapSpotsF3 = vApp.$store.state.maps.shopsf3.spots;
        vApp.arrBase =vApp.getBasePoints(1);
        vApp.arrFloor =vApp.getShopPoints(1);
/*         let container = document.getElementById('fullmap'); */
        if(DEBUG) console.log('container :', vApp.mapBlock);
        if(DEBUG) console.log('arrFloor :', vApp.arrFloor);
        if(DEBUG) console.log('vApp.mapSpotsF1 :', vApp.mapSpotsF1);
        if(DEBUG) console.log('vApp.mapSpotsF2 :', vApp.mapSpotsF2);
        if(DEBUG) console.log('vApp.mapSpotsF3 :', vApp.mapSpotsF3);

        vApp.camera = new THREE.PerspectiveCamera(50, vApp.mapBlock.clientWidth/vApp.mapBlock.clientHeight, 1.0, 1600);
        vApp.camera2 = new THREE.PerspectiveCamera(50, vApp.mapBlock.clientWidth/vApp.mapBlock.clientHeight, 1.0, 1600);
        //vApp.camera = new THREE.PerspectiveCamera(50, container.clientWidth/container.clientHeight, 0.01, 10);

        //vApp.camera.position.set( 190, 220, -200 );
if(vApp.isMobile){
          vApp.camera.fov = 25;
          vApp.camera.zoom = 2.2;
  /*         vApp.camera.aspect = vApp.mapBlock.offsetWidth / vApp.mapBlock.offsetHeight;
          vApp.camera.updateProjectionMatrix();
          vApp.renderer.setSize(vApp.mapBlock.offsetWidth , vApp.mapBlock.offsetHeight);
 */

      vApp.camera.position.set( 55, 90, -100 );
      vApp.camera.rotation.set (-0.90*Math.PI, -0.01*Math.PI, 0.0*Math.PI);

        if(DEBUG) console.log('vApp.camera :', vApp.camera);
}
else{
      vApp.camera.position.set( 220, 320, -250 );
        vApp.camera.rotation.set (-0.85*Math.PI, 0.0*Math.PI, 0.0*Math.PI);
        vApp.camera.fov = 25;
        vApp.camera.zoom = 2.2;
        if(DEBUG) console.log('vApp.camera :', vApp.camera);
}
  
        vApp.camera2.position.set( 220, 60, -10 );
        vApp.camera2.rotation.set (-0.75*Math.PI, 0.0*Math.PI, 0.0*Math.PI);

        //vApp.camera.position.set( 0.3, 0.2, 2 );
        //vApp.camera.position.z = 1;
				// LIGHTS


        vApp.scene = new THREE.Scene();


        vApp.raycaster = new THREE.Raycaster();
        vApp.mouse = new THREE.Vector2();


				// Lights

/*				vApp.scene.add( new THREE.AmbientLight( 0x333311 ) );

/* 				var directionalLight = new THREE.DirectionalLight( 0xdddddd, 1.0 );

				directionalLight.position.x =   0.2;
				directionalLight.position.y =   0.2;
				directionalLight.position.z =  -1.2;
        directionalLight.castShadow = true;
				directionalLight.position.normalize();

				vApp.scene.add( directionalLight );

			let	lightHelper = new THREE.DirectionalLightHelper( directionalLight, 25 );
				vApp.scene.add( lightHelper ); */

      let spotLight = new THREE.SpotLight( 0xffffff );
      spotLight.position.set( 250, -250, -1610 );

      spotLight.castShadow = true;
      spotLight.penumbra = 0.7;
      spotLight.power = 1.6;

      spotLight.shadow.radius = 22;

      spotLight.shadow.mapSize.width = 1024+256;
      spotLight.shadow.mapSize.height = 1024+256;

      spotLight.shadow.camera.near = 10;
      spotLight.shadow.camera.far = 1700;
      spotLight.shadow.camera.fov = 70;
      spotLight.shadow.camera.left = -120
      spotLight.shadow.camera.right = 120
      spotLight.shadow.camera.top = 120
      spotLight.shadow.camera.bottom = -120
/*       let targetObject = new THREE.Object3D();
    //  vApp.scene.add(targetObject);
      targetObject.position.set( 300, 260, -120 );
      spotLight.target = targetObject;

      vApp.scene.add( spotLight.target );

      */
      vApp.scene.add( spotLight );

      let spotLightHelper = new THREE.SpotLightHelper( spotLight );
      vApp.scene.add( spotLightHelper );

      let helper = new THREE.CameraHelper( spotLight.shadow.camera );
    //  vApp.scene.add( helper );

/*         vApp.light = new THREE.PointLight( 0xffddff, 2,12 );
        vApp.light.castShadow = true;
				vApp.scene.add( vApp.light );



        let	hemiLight = new THREE.HemisphereLight( 0xddeeff, 0x111111, 2.2 );

				vApp.scene.add( hemiLight ); */
        var light = new THREE.AmbientLight( 0x404040,2 ); // soft white light
        vApp.scene.add( light );

        let geometry = new THREE.BoxGeometry(0.2, 0.2, 0.2);
        let material = new THREE.MeshNormalMaterial();


      //  vApp.mesh = new THREE.Mesh(geometry, material);
      //   vApp.scene.add(vApp.mesh);
        vApp.addShapeObj(vApp.arrBase,vApp.arrFloor,1);

        vApp.renderer = new THREE.WebGLRenderer({
          antialias: true,
          alpha: true,
        //  canvas: vApp.mapBlock.children,
          });
        vApp.renderer.shadowMap.enabled = true;
        vApp.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        vApp.renderer.setSize(vApp.mapBlock.clientWidth, vApp.mapBlock.clientHeight);
        vApp.mapBlock.appendChild(vApp.renderer.domElement);
        if(DEBUG) console.log('vApp.renderer :', vApp.renderer);

        vApp.mapBlock.addEventListener( 'mouseup', vApp.onDocumentMouseUp, false );
        vApp.mapBlock.addEventListener( 'mousemove', vApp.onDocumentMouseMove, false );
        if (vApp.$route.name === 'MapPageSingle') {
          vApp.selectFloor(vApp.selectShop.floor);
        }

				// controls


    },
    animate() {
      let vApp = this;
        requestAnimationFrame(vApp.animate);
      //  this.mesh.rotation.x += 0.01;
      //  this.mesh.rotation.y += 0.002;
        vApp.render();
        vApp.update();
      // vApp.controls.update();
      // vApp.stats.update();
      // this.renderer.render(this.scene, this.camera);
        if ( vApp.needsResize ) {
            vApp.needsResize = false;
            vApp.updateViewport();
          }

    },
      update() {
        // find intersections
        let vApp = this;
        // create a Ray with origin at the mouse position
        //   and direction into the scene (camera direction)

        let vector = new THREE.Vector3(vApp.mouse.x, vApp.mouse.y, 1);

        vector.unproject(vApp.camera);
        
        vApp.raycaster = new THREE.Raycaster(vApp.camera.position, vector.sub(vApp.camera.position).normalize());

        // create an array containing all objects in the scene with which the ray intersects
        vApp.intersects = vApp.raycaster.intersectObjects(vApp.scene.children, true);
        if (vApp.intersects.length > 0) {

          /*
          * DEBUG: !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Постоянный рендер !!!!!!!!!!!!!!!!!!!!!!!!!!!!!
          */
          //if(DEBUG) console.log('intersects[0].object.name :', vApp.intersects[0].object.name);           

          if(vApp.intersects[0].object.name !== 'base' && vApp.intersects[0].object.name !== 'sh-off' && vApp.intersects[0].object.name.split('-')[2] !== 'x') {
            if(vApp.mMove){
          vApp.hoverShopID = vApp.intersects[0].object.name;
            }
          for (let xg = 0; xg < vApp.groupFl1.children.length; xg++) {
            const elch = vApp.groupFl1.children[xg];
            if(elch.name !== 'base' && elch.name !== 'sh-off' && elch.name !== vApp.idSelectShop && elch.name.split('-')[2] !== 'x'){
            elch.material = vApp.grpMaterial;
            }
          }
          if(vApp.mMove){

            
          vApp.intersects[0].object.material = vApp.selectMaterial;
          }
          }
          else{
            vApp.hoverShopID = 'none';
            for (let xg = 0; xg < vApp.groupFl1.children.length; xg++) {
              const elch = vApp.groupFl1.children[xg];
              if(elch.name !== 'base' && elch.name !== 'sh-off' && elch.name !== vApp.idSelectShop && elch.name.split('-')[2] !== 'x'){
                elch.material = vApp.grpMaterial;
            }
          }
          }
          
        }
        else{
          vApp.hoverShopID = 'none';
        for (let xg = 0; xg < vApp.groupFl1.children.length; xg++) {
          const elch = vApp.groupFl1.children[xg];
          if(elch.name !== 'base' && elch.name !== 'sh-off' && elch.name !== vApp.idSelectShop && elch.name.split('-')[2] !== 'x'){
          elch.material = vApp.grpMaterial;
          }
        }
       

        }



/*         controls.update();
        stats.update(); */
      },
    deleteShapeObj(){
      let vApp = this;

          let selectedObject = vApp.scene.getObjectByName('base');
          if(DEBUG) console.log('Delete selectedObject = ',selectedObject);
          vApp.scene.remove(selectedObject);
      for (let i = vApp.groupFl1.children.length - 1; i >= 0; i--) {

          vApp.groupFl1.remove(vApp.groupFl1.children[i]);
      }
      if(DEBUG) console.log('Delete groupFloor1 = '+vApp.groupFl1.children.length);
      if(DEBUG) console.log('Delete scene', vApp.scene);
    },
    addShapeObj(basePoints,floorPoints,floorN){


        let vApp = this;

        vApp.deleteShapeObj();
        vApp.shopsShape = [];
        vApp.floorShape = [];
				let californiaPts = [];
        let floorPts = [];
        let shopsPts = [];
        let group = new THREE.Group();
        let textureLoader = new THREE.TextureLoader();

        let material = new THREE.MeshNormalMaterial();
        let material1 = new THREE.MeshLambertMaterial( { color: 0xdddddd } ) ;

        let material3 = new THREE.MeshBasicMaterial( { color: 0xaaaaaa, transparent: true,wireframe: false, blending: THREE.NormalBlending, flatShading: true,opacity: 0.7 } );
        let material4 = new THREE.MeshLambertMaterial( { color: 0xa1dddd,transparent: true,opacity: 0.5} );
        let material5 = new THREE.MeshNormalMaterial( { flatShading: true } ) ;
        let material6 = new THREE.MeshPhongMaterial( { color: 0xff1f00, wireframe: false } ) ;
        vApp.selectMaterial = material6;
        let material7 = new THREE.MeshDepthMaterial()  ;
        let material8 = new THREE.MeshLambertMaterial( { color: 0x660000, emissive: 0x660000 } ) ;
        let matFloor1 = new THREE.MeshPhongMaterial(
          {
          color: 0xbd1a8d,
      //  specular: 0xaaaa66,
      //    emissive: 0x222222,
      //    shininess: 1,
          opacity: 1.0,
          transparent: true
          }
          );
        let matFloor2 = new THREE.MeshPhongMaterial(
          {
          color: 0xf8931d,
      //  specular: 0xaaaa66,
      //    emissive: 0x222222,
      //    shininess: 1,
          opacity: 1.0,
          transparent: true
          }
          );
        let matFloor3 = new THREE.MeshPhongMaterial(
          {
          color: 0xffca08,
      //  specular: 0xaaaa66,
      //    emissive: 0x222222,
      //    shininess: 1,
          opacity: 1.0,
          transparent: true
          }
          );




        let shadowMat = new THREE.ShadowMaterial();
       // shadowMat.opacity = 0.7;

              vApp.cubeMat = new THREE.MeshStandardMaterial( {
                  roughness: 0.4,
                  color: 0xffffff,
                  bumpScale: 0.02,
                  metalness: 0.02,
                  opacity: 0.6,
                  transparent: true
                } );



        if(DEBUG) console.log('basePoints numShapes:', basePoints.length);

        for (let ip = 0; ip < basePoints.length; ip++) {
          const elb = basePoints[ip];
          let oneShape = [];
          for (let kl = 0; kl < elb.length; kl++) {
            const pb = elb[kl];
          //  if(DEBUG) console.log('basePoints pb :', pb);
            oneShape.push( new THREE.Vector2( pb.x, pb.y ) );
          }
          floorPts.push( oneShape );

        }

        if(DEBUG) console.log('floorPoints numShops :', floorPoints.length);
        for (let ip = 0; ip < floorPoints.length; ip++) {
          const elb = floorPoints[ip];
          let oneShape = [];
        //  if(DEBUG) console.log('floorPoints step :', elb.length);
          for (let kl = 0; kl < elb.length; kl++) {
            const pb = elb[kl];
          //  if(DEBUG) console.log('floorPoints pb :', pb);
            oneShape.push( new THREE.Vector2( pb.x, pb.y ) );
          }
           shopsPts.push( oneShape);
        }
        for ( let i = 0; i < floorPts.length; i ++ ) {
          for ( let j = 0; j < floorPts[i].length; j ++ ) {
            floorPts[i][ j ].multiplyScalar( 0.3 );
          }
          vApp.floorShape.push( new THREE.Shape( floorPts[i] ));
        }

        for ( let i = 0; i < shopsPts.length; i ++ ) {
          for ( let j = 0; j < shopsPts[i].length; j ++ ) {
            shopsPts[i][ j ].multiplyScalar( 0.3 );
          }
          vApp.shopsShape.push( new THREE.Shape( shopsPts[i] ));
        }

        let extrudeSettings,extrudeSettings2,extrudeSetSelect;
        if(vApp.isMobile){
          extrudeSettings = { depth: 2, bevelEnabled: true, bevelSegments: 2, steps: 1, bevelSize: 1, bevelThickness: 1 };
          extrudeSettings2 = { depth: 4, bevelEnabled: false, bevelSegments: 2, steps: 1, bevelSize: 1, bevelThickness: 1 };
          extrudeSetSelect = { depth: 2, bevelEnabled: false, bevelSegments: 2, steps: 1, bevelSize: 1, bevelThickness: 1 };
        }
        else{
          extrudeSettings = { depth: 3, bevelEnabled: true, bevelSegments: 2, steps: 1, bevelSize: 1, bevelThickness: 1 };
          extrudeSettings2 = { depth: 12, bevelEnabled: false, bevelSegments: 2, steps: 1, bevelSize: 1, bevelThickness: 1 };
          extrudeSetSelect = { depth: 22, bevelEnabled: false, bevelSegments: 2, steps: 1, bevelSize: 1, bevelThickness: 1 };
        }

        if(DEBUG) console.log('vApp.floorShape :', vApp.floorShape);
        if(DEBUG) console.log('vApp.shopsShape :', vApp.shopsShape);
        vApp.addShape( vApp.floorShape, extrudeSettings,'base', material1, 0, 0, 0, 0.0*Math.PI, 0.0*Math.PI, 0.0*Math.PI , 1 );
        let mapSpotsArr = null;
        let matGrpShop = null;
        let emptyShop = null;
        let idShp = this.$route.params.idShop;
if(DEBUG) console.log('          idShp :', idShp);
        switch (floorN) {
          case 1:
           mapSpotsArr= vApp.mapSpotsF1;
           matGrpShop= matFloor1;
           vApp.grpMaterial = matGrpShop;
            break;
          case 2:
           mapSpotsArr= vApp.mapSpotsF2;
           matGrpShop= matFloor2;
           vApp.grpMaterial = matGrpShop;
            break;
          case 3:
           mapSpotsArr= vApp.mapSpotsF3;
           matGrpShop= matFloor3;
           vApp.grpMaterial = matGrpShop;

           if(DEBUG) console.log('mapSpotsArr :', mapSpotsArr);
           if(DEBUG) console.log('matGrpShop :', matGrpShop);
            break;

          default:
            break;
        }

        for ( let i = 0; i < vApp.shopsShape.length; i ++ ) {
        //  if(DEBUG) console.log('mapSpotsArr[i].title :', mapSpotsArr[i].title.split('-')[2]);
          if(mapSpotsArr[i].title === 'sh-off' || mapSpotsArr[i].title.split('-')[2] == 'x'){

            vApp.addShapeToGroup(floorN, vApp.shopsShape[i], mapSpotsArr[i].title, extrudeSettings2,  matGrpShop, 0, 0, -12, 0.0*Math.PI, 0.0*Math.PI, 0.0*Math.PI , 1 );

          }
          else{

          //  if(DEBUG) console.log('vApp.$route name :', vApp.$route.name);
            if (vApp.$route.name === 'MapPageSingle') {
          //  if(DEBUG) console.log('MapPageSingle');
            if(DEBUG) console.log('idShp :', idShp);
            
              if(mapSpotsArr[i].title === 'sh-'+ vApp.allSh.find(fsh=>fsh.id === idShp).idmapshop ){
                  if(DEBUG) console.log('  ##############   vApp.shops.find(fsh=>fsh.id === idShp) :', vApp.shops.find(fsh=>fsh.id === idShp));
                  vApp.addShapeToGroup(floorN, vApp.shopsShape[i], mapSpotsArr[i].title, extrudeSetSelect, vApp.selectMaterial, 0, 0, -22, 0.0*Math.PI, 0.0*Math.PI, 0.0*Math.PI , 1 );
              
              }
              else{
                  vApp.addShapeToGroup(floorN, vApp.shopsShape[i], mapSpotsArr[i].title, extrudeSettings2, matGrpShop, 0, 0, -12, 0.0*Math.PI, 0.0*Math.PI, 0.0*Math.PI , 1 );
              
              }
            }
            else{
          //  if(DEBUG) console.log('MapPage');
          //  if(DEBUG) console.log('mapSpotsArr[i].title :', mapSpotsArr[i].title);
              emptyShop = vApp.shops.find(fnull=>fnull.idmapshop===mapSpotsArr[i].title.slice(3));
              if(DEBUG) console.log('emptyShop :', emptyShop);
              if(typeof emptyShop !== 'undefined') {
                vApp.addShapeToGroup(floorN, vApp.shopsShape[i], mapSpotsArr[i].title, extrudeSettings2, matGrpShop, 0, 0, -12, 0.0*Math.PI, 0.0*Math.PI, 0.0*Math.PI , 1 );
              }
              else{
                vApp.addShapeToGroup(floorN, vApp.shopsShape[i], mapSpotsArr[i].title, extrudeSettings2, material1, 0, 0, -12, 0.0*Math.PI, 0.0*Math.PI, 0.0*Math.PI , 1 );
              }
            
            }

        }
        }
        vApp.scene.add( vApp.groupFl1);
    },
    addShape( shape, extrudeSettings,nameShape, material, x, y, z, rx, ry, rz, s ) {
          let vApp = this;
					// extruded shape

          let geometry = new THREE.ExtrudeBufferGeometry( shape, extrudeSettings );
          vApp.mesh = new THREE.Mesh( geometry, material);
          vApp.mesh.castShadow = false;
					vApp.mesh.receiveShadow = false;
					vApp.mesh.position.set( x, y, z );
					vApp.mesh.rotation.set( rx, ry, rz );
          vApp.mesh.scale.set( s, s, s );
          vApp.mesh.name =  nameShape;
					vApp.scene.add( vApp.mesh );

				},
    addShapeToGroup( floor, shape,nameShape, extrudeSettings, material, x, y, z, rx, ry, rz, s ) {
          let vApp = this;
					// extruded shape

          let geometry = new THREE.ExtrudeBufferGeometry( shape, extrudeSettings );
          vApp.mesh = new THREE.Mesh( geometry, material);
          vApp.mesh.castShadow = true;
					vApp.mesh.receiveShadow = false;

					vApp.mesh.position.set( x, y, z );
					vApp.mesh.rotation.set( rx, ry, rz );
          vApp.mesh.scale.set( s, s, s );
          vApp.mesh.name = nameShape ;

        //  if(DEBUG) console.log('vApp.mesh :', vApp.mesh);
          switch (floor) {
            case 1:
              vApp.groupFl1.add( vApp.mesh );
              break;
            case 2:
              vApp.groupFl1.add( vApp.mesh );
              break;
            case 3:
              vApp.groupFl1.add( vApp.mesh );
              break;

            default:
              break;
          }


				},


			 onDocumentMouseMove( event ) {
        let vApp = this;

        vApp.mMove = true

      //  if(DEBUG) console.log('event : ', event);
      //  if(DEBUG) console.log('mapBlock: ', vApp.mapBlock);
/*         if(DEBUG) console.log('getBoundingClientRect() ', vApp.mapBlock.getBoundingClientRect());
        if(DEBUG) console.log('offsetParent : %s', vApp.mapBlock.offsetParent);
        if(DEBUG) console.log('offsetLeft : %s offsetWidth: %s', vApp.mapBlock.offsetLeft,vApp.mapBlock.offsetWidth); */
				vApp.mouse.x = (( event.clientX- vApp.mapBlock.offsetLeft- (vApp.mapBlock.getBoundingClientRect().x - vApp.mapBlock.offsetLeft) ) / vApp.mapBlock.offsetWidth ) * 2 - 1;
				vApp.mouse.y = - (( event.offsetY ) / vApp.mapBlock.offsetHeight ) * 2 + 1;
      //  if(DEBUG) console.log('vApp.mouse X : %s Y: %s', vApp.mouse.x,vApp.mouse.y);


			},

			 onDocumentMouseUp(event) {
        let vApp = this;

				document.removeEventListener( 'mouseout', vApp.onDocumentMouseOut, false );
        event.preventDefault();

      //  if(DEBUG) console.log("event=", event);

        if(DEBUG) console.log('event.client X= %s Y= %s :', event.clientX, event.clientY);
        if(DEBUG) console.log(' vApp.mapBlock.offsetLeft :', vApp.mapBlock.offsetLeft);
        if(DEBUG) console.log(' vApp.mapBlock.offsetTop :', vApp.mapBlock.offsetTop);
        if(DEBUG) console.log(' event.screenY= %s clientY= %s offsetY= %s  pageY= %s ', event.screenY , event.clientY, event.offsetY,  event.pageY);


        vApp.raycaster.setFromCamera( vApp.mouse, vApp.camera );

        let intersects = vApp.raycaster.intersectObjects( vApp.scene.children, true );
        let getidmap = null;

        if(DEBUG) console.log('mouseup intersects :', intersects[0]);
          if (intersects.length >0) {
                if(intersects[0].object.name !== 'base' && intersects[0].object.name !== 'sh-off' ) {
                getidmap = intersects[0].object.name;
                if(DEBUG) console.log('CLICK  vApp.mouse X= %s Y= %s', vApp.mouse.x, vApp.mouse.y);
                if(DEBUG) console.log('CLICK object :', intersects[0].object);
                if(DEBUG) console.log('CLICK intersects[0].object.name :', getidmap.slice(3));

                vApp.isViewBtnGotoShop = false
                 vApp.getIdClickShop = vApp.allSh.find(clksh=>clksh.idmapshop === getidmap.slice(3));
                if(DEBUG) console.log('getIdClickShop :', vApp.getIdClickShop);
                    if(typeof vApp.getIdClickShop !== 'undefined') {
                      if(vApp.isMobile){
                      vApp.isViewBtnGotoShop = true
                      if(DEBUG) console.log('[[[[[[[[[[[[[[[[[[[[[[[[[[[ CLICK ]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]>--------- GOTO ', vApp.getIdClickShop.id)
                      
                    }
                    else{
                      if(DEBUG) console.log('[[[[[[[[[[[[[[[[[[[[[[[[[[[ CLICK ]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]>--------- GOTO ', vApp.getIdClickShop)
                      vApp.slectShopFromAllMap(vApp.getIdClickShop)
                    }
                    }
                }
          }
			},
    render (){
      let vApp = this;
      vApp.renderer.render(vApp.scene, vApp.camera);
      vApp.renderer.shadowMap.enabled = true;
      vApp.renderer.shadowMap.type = THREE.BasicShadowMap;
      vApp.cubeMat.needsUpdate = true;
    }
  },

  mounted() {
  let vApp = this;
      this.$nextTick(function () {
      if(DEBUG) console.log('mounted AllMapPage');
      vApp.mapBlock = document.getElementById('fullmap');
      let getAllSh =  vApp.$store.state.shops.shops;

      if( getAllSh !== null) {
        if(vApp.scene === null){
          vApp.init();
          vApp.animate();

        setTimeout(function() {
              vApp.selectFloor('1');
        }, 500);
        }

          if(DEBUG) console.log('attr Route  :', vApp.$route.params.idShop);
      }

          window.addEventListener("resize", vApp.resizeThrottler, false);
  })
  },
  beforeDestroy: function () {
      let vApp = this;
      if(DEBUG) console.log("Удаляем КАРТУ ЗДАНИЯ");
				document.removeEventListener( 'mousemove', vApp.onDocumentMouseMove, false );
				document.removeEventListener( 'mouseup', vApp.onDocumentMouseUp, false );
				document.removeEventListener( 'mouseout', vApp.onDocumentMouseOut, false );

  }
};
</script>

<style scoped>
.maprender{
  width: 100%;
  height: 35vh;
  margin: auto;
/*   background: #ddd;  */
}
.info-shop{
  height: 60px;
}
.full-map-row{
  width: 100%;
}
</style>